import { concat, isEmpty, get, cloneDeep } from 'lodash';
import PurchaseType from './Purchase.type';
import { Page_Size } from '../../../../../Components/helper';

const initialState = {
  purchaseListData: [],
  purchaseSelectedIds: [],
  purchaseTodoList: [],
  mainSamples: [],
  createdByUser: [],
  purchaseFilterValues: {
    selectedpurchase_Season: [],
    selectedpurchase_Year: [],
    selectedpurchase_Brand: [],
    selectedpurchase_Supplier: [],
    selectedpurchase_Type: '',
    selectedpurchase_Category1: [],
    selectedpurchase_Category2: [],
    selectedpurchase_Category3: [],
    selectedpurchase_Category4: [],
    selectedpurchase_Section: '',
    selectedpurchase_Status: '',
    selectedPurchase_CreatedBy: [],
    selectedPurchase_Currency: [],
    selectedPurchase_ShipMethod: [],
    incoterms: [],
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
    pageIndex: 1,
    pageSize: Page_Size,
    sortOrder: '',
    sortPropertyName: '',
    loading: false,
  },
  purchaseListTotalCount: 0,
};

const purchaseTodoListReducer = (state = initialState, action) => {
  switch (action.type) {
    case PurchaseType.SET_PURCHASE_REQUESTS_TODOLIST:
      const updatedArry = cloneDeep(setArrayByCase(state.purchaseListData, action.payload));
      return {
        ...state,
        purchaseListData: updatedArry,
        purchaseListTotalCount: action.payload.totalCount,
      };
    case PurchaseType.SET_CREATED_BY_USER:
      return {
        ...state,
        createdByUser: action.payload,
      };
    case PurchaseType.SET_SELECTED_IDS_ARRAY:
      return {
        ...state,
        purchaseSelectedIds: action.payload,
      };
    case PurchaseType.SET_FILTER_SORT_DATA:
      return {
        ...state,
        purchaseFilterValues: {
          ...state.purchaseFilterValues,
          ...action.payload,
        },
      };
    case PurchaseType.GET_MAIN_SAMPLES:
      return {
        ...state,
        mainSamples: action.payload,
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    array = [...array, ...payload.data];
    return array;
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    array = payload.data;
    return array;
  }
  if (get(payload, 'isScrolled')) {
    array = concat(array, payload.data);
    return array;
  }

  return payload.data;
};

export default purchaseTodoListReducer;
